/**
 * Default table settings for ItemListView
 * 
 * Provides fallback column configurations when users have no saved settings
 * in `Settings.tables.<key>`. These defaults were exported from Luke's userdata
 * and serve as the initial state for all table views.
 * 
 * Each key corresponds to a `meta.tableSettings` value used in route configuration.
 */

import sourceSettings from './defaultTableSettings.source.json';

/**
 * Get default table settings for a given table key
 * @param {string} key - The tableSettings key (e.g. "Commercials", "JobCards", "MilitaryDrawings")
 * @returns {object|null} - The default table settings or null if no defaults exist for this key
 */
export function getDefaultTableSettings(key) {
  if (!key || typeof key !== 'string') {
    return null;
  }
  
  return sourceSettings[key] || null;
}

/**
 * All default table settings indexed by key
 */
export const defaultTableSettings = sourceSettings;

/**
 * List of all available default table setting keys
 */
export const availableKeys = Object.keys(sourceSettings);

export default {
  getDefaultTableSettings,
  defaultTableSettings,
  availableKeys
};
